import { staleTimes, useQueries } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';
import { MOVEMENT_STATES, type MovementState } from './inventory.ts';

const COUNT_PAGE = 1;

export type MovementCounts = ReadonlyMap<MovementState | 'all', number>;

export type MovementScope = { readonly depot: string | null; readonly productId: string | null };

export const useMovementCounts = (api: TypedClient, { depot, productId }: MovementScope): MovementCounts => {
  const { tenantId } = usePageContext();
  const scopes = ['all', ...MOVEMENT_STATES] as const;
  const results = useQueries({
    queries: scopes.map((scope) => ({
      queryKey: queryKeys.movements(tenantId, { counted: scope, depot, productId }),
      queryFn: () =>
        api.get('/admin/stock-movements', {
          query: {
            page_size: COUNT_PAGE,
            ...(scope === 'all' ? {} : { state: scope }),
            ...(depot === null ? {} : { location_id: depot }),
            ...(productId === null ? {} : { product_id: productId }),
          },
        }),
      staleTime: staleTimes.inventory,
    })),
  });
  return new Map(
    scopes.flatMap((scope, index) => {
      const total = results[index]?.data?.total;
      return total === undefined ? [] : [[scope, total] as const];
    }),
  );
};
